import {
  AlertTitle,
  AlertDescription,
  Box,
  Alert,
  CloseButton,
  Text,
  AlertIcon,
  Link as ChakraLink,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../app/typedReduxHooks'
import { RootState } from '../../../app/store'
import { format } from 'date-fns'
import { setHasSentLowTokenNotification } from '../BillingSlice'
import { routes } from '../../routes'
import { isOwnerOrSuperAdminCapable } from '../../../features/users/utils/organizationAdminCapabilities'

export const LowRemainingTokensNotificationContent = () => {
  const organizationAdmin = useAppSelector((state: RootState) => state.organizationAdmin.profile)
  const {
    data: billingData,
    warning,
    hasSentLowTokenNotification,
  } = useAppSelector((state: RootState) => state.billing?.subscription)
  const dispatch = useAppDispatch()

  const isOwnerOrSuperAdmin = isOwnerOrSuperAdminCapable(organizationAdmin)
  const isAbleToManageBilling = billingData?.stripeSubscriptionId && isOwnerOrSuperAdmin

  const handleClose = () => {
    dispatch(setHasSentLowTokenNotification(true))
  }

  return !hasSentLowTokenNotification && warning?.code ? (
    <Alert status="warning" variant="left-accent">
      <AlertIcon />
      <Box flex={1}>
        <AlertTitle>Low Remaining Tokens</AlertTitle>
        <AlertDescription>
          <Text>
            You only have{' '}
            <Text as="span" fontWeight="bold">
              {billingData?.remainingTokens}
            </Text>{' '}
            more prescriptions left until{' '}
            <Text as="span" fontWeight="bold">
              {billingData?.currentPeriodEnd &&
                format(new Date(billingData.currentPeriodEnd), 'dd/MM/yyyy')}
            </Text>
            .{' '}
            {isOwnerOrSuperAdmin ? (
              <>
                {isAbleToManageBilling ? (
                  <>
                    <Link to="/settings?tab=subscription" style={{ color: 'dodgerblue' }}>
                      Upgrade
                    </Link>{' '}
                    your subscription now to avoid interruptions.
                  </>
                ) : (
                  <>
                    <ChakraLink href="mailto:support@rxpad.com.au" style={{ color: 'dodgerblue' }}>
                      Contact us
                    </ChakraLink>{' '}
                    to upgrade your subscription.
                  </>
                )}
              </>
            ) : (
              <>
                Contact your organisation owner now to upgrade to unlimited. Click{' '}
                <Link to={`${routes.settings.path}?tab=users`} style={{ color: 'dodgerblue' }}>
                  here
                </Link>{' '}
                to check organisation owner.
              </>
            )}
          </Text>
        </AlertDescription>
      </Box>
      <CloseButton
        alignSelf="flex-start"
        position="relative"
        right={-1}
        top={-1}
        onClick={handleClose}
      />
    </Alert>
  ) : null
}
